module.exports = __webpack_public_path__ + "img/user06.8f55e7e7.png";